import Helper from './Helper';

class SustainabilityTabs {
  constructor(config = {}) {
    const {
      tabButtonSelector,
      tabSelector
    } = config;
    this.tabButtons = Array.prototype.slice.call(document.querySelectorAll(tabButtonSelector));
    this.tabs = Array.prototype.slice.call(document.querySelectorAll(tabSelector));

    if (this.tabButtons && this.tabs) {
      this.bindEvents();
    }
  }

  bindEvents() {
    this.tabButtons.forEach(button => {
      button.addEventListener( 'click', e => {
        const currentTab = button.getAttribute('data-target-tab');

        this.tabButtons.forEach(button => {
          if (Helper.hasClass(button, 'active')) {
            Helper.removeClass(button, 'active');
          }
        });
        Helper.addClass(button, 'active');

        this.tabs.forEach(tab => {
          const tabName = tab.getAttribute('data-tab');
          if (tabName == currentTab) {
            Helper.addClass(tab, 'active');
          } else {
            Helper.removeClass(tab, 'active');
          }
        });
      });
    });
  }
}

export default SustainabilityTabs;
